var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinnerCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F6475F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.1668H10C9.26667 16.1668 8.66667 16.7668 8.66667 17.5001V17.6668H8C7.72667 17.6668 7.5 17.8935 7.5 18.1668C7.5 18.4401 7.72667 18.6668 8 18.6668H16C16.2733 18.6668 16.5 18.4401 16.5 18.1668C16.5 17.8935 16.2733 17.6668 16 17.6668H15.3333V17.5001C15.3333 16.7668 14.7333 16.1668 14 16.1668H12.5V14.6401C12.3333 14.6601 12.1667 14.6668 12 14.6668C11.8333 14.6668 11.6667 14.6601 11.5 14.6401V16.1668Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3205 11.7602C16.7605 11.5935 17.1472 11.3202 17.4538 11.0135C18.0738 10.3268 18.4805 9.50683 18.4805 8.54683C18.4805 7.58683 17.7272 6.8335 16.7672 6.8335H16.3938C15.9605 5.94683 15.0538 5.3335 14.0005 5.3335H10.0005C8.94717 5.3335 8.04051 5.94683 7.60717 6.8335H7.23384C6.27384 6.8335 5.52051 7.58683 5.52051 8.54683C5.52051 9.50683 5.92717 10.3268 6.54717 11.0135C6.85384 11.3202 7.24051 11.5935 7.68051 11.7602C8.37384 13.4668 10.0405 14.6668 12.0005 14.6668C13.9605 14.6668 15.6272 13.4668 16.3205 11.7602ZM13.8938 9.6335L13.4805 10.1402C13.4138 10.2135 13.3672 10.3602 13.3738 10.4602L13.4138 11.1135C13.4405 11.5135 13.1538 11.7202 12.7805 11.5735L12.1738 11.3335C12.0805 11.3002 11.9205 11.3002 11.8272 11.3335L11.2205 11.5735C10.8472 11.7202 10.5605 11.5135 10.5872 11.1135L10.6272 10.4602C10.6338 10.3602 10.5872 10.2135 10.5205 10.1402L10.1072 9.6335C9.84717 9.32683 9.96051 8.98683 10.3472 8.88683L10.9805 8.72683C11.0805 8.70016 11.2005 8.60683 11.2538 8.52016L11.6072 7.9735C11.8272 7.6335 12.1738 7.6335 12.3938 7.9735L12.7472 8.52016C12.8005 8.60683 12.9205 8.70016 13.0205 8.72683L13.6538 8.88683C14.0405 8.98683 14.1538 9.32683 13.8938 9.6335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnerCup);
export default __webpack_public_path__ + "static/media/winner-cup.404636751419ff90b31ed8afd4d4aa9b.svg";
export { ForwardRef as ReactComponent };